import { palette, typography, layouts, animations } from '../../theme';

export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 2,
    flex: 1,
    ...animations.appearanceEffect,
  },
  title: {
    width: '100%',
    fontFamily: typography.fontFamily,
    fontStyle: 'normal',
    fontWeight: typography.h2.fontWeight,
    fontSize: typography.h2.fontSize,
    lineHeight: typography.h2.lineHeight,
    color: palette.text.primary,
    textAlign: 'left',
    marginBottom: 2,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 1.5,
    height: 'calc(100vh - 96px)',
    backgroundColor: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: 1,
    ...animations.fadeInEffect,
  },
};
